import React, { useEffect, useMemo, useState } from 'react';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import { Link } from 'react-router-dom';
import { ChevronRight, Edit2, X, Plus } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { object, string, array } from 'yup';
import { fetchEvents, getEvents } from '../../app/reducers/Event/eventSlice';
import TableWithHeading from '../../components/Table/TableWithHeading';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import DangerButton from '../../components/infrastructure/Buttons/DangerButton';
import DescriptionModal from '../Participant/DescriptionModal';
import DetailsModal from '../Participant/DetailsModal';
import WarOfClDisclaimer from './WarOfClDisclaimer';
import { getAuth } from '../../app/reducers/Auth/authSlice';
import QueryString from 'qs';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { getFeatures } from '../../app/reducers/Features/featuresSlice';
import { ClipLoader } from 'react-spinners';
import { useFormik } from 'formik';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import { toast } from 'react-toastify';


const WarOfCLRegistration = ({ actionFeatures }) => {
    const { user } = useSelector(getAuth);
    const { event } = useSelector(getEvents);
    console.log('event', event?.docs)
    const [requestData, setRequestData] = useState({});
    const { features } = useSelector(getFeatures);
    const [clData, setClData] = useState({});
    const [warClData, setWarClData] = useState([]);
    const [showDescriptionModal, setShowDescriptionModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);
    const [canShowRegistration, setCanShowRegistration] = useState(true);
    const [rules, setRules] = useState([]);
    const [isEditingRules, setIsEditingRules] = useState(false);
    const [rulesLoading, setRulesLoading] = useState(false);

    const fetchRules = async () => {
        try {
            setRulesLoading(true);
            const resp = await authAxiosInstance.get('/warOfClRules/getRules');
            const fetchedRules = resp?.data?.data?.rules || [];
            setRules(fetchedRules);
            rulesFormik.setFieldValue('rules', fetchedRules);
        } catch (error) {
            console.log(error);
        } finally {
            setRulesLoading(false);
        }
    };
    const canEditRules = ['Developer','Super User','HOD','Admin Head',].includes(user?.role?.name);

    const computeWarOfCls = async () => {
        try {
            const string = QueryString.stringify({});
            const string1 = QueryString.stringify({ collegeCode: user?.username });

            const resp = await authAxiosInstance.get(`/warOfCl?${string}`);
            const resp1 = await authAxiosInstance.get(`/warOfCl?${string1}`);
            console.log('resp', resp?.data?.data);
            setWarClData(resp?.data?.data?.docs);
            setClData(resp1?.data?.data?.docs[0]);
        } catch (error) {
            console.log(error);
        }
    };
    console.log('cl data', clData);
    console.log('user', user)

    const dispatch = useDispatch();
    const actionsBtn = ['Registration'];
    const createFeatureActionsConfig = (actionFeatures, actions) => {
        const config = {};
        actionFeatures?.forEach((ids, index) => {
            config[ids] = actions[index];
        });
        return config;
    };

    const computeActiveFeature = () => {
        const buttonStateSetter = {
            'Registration': setCanShowRegistration,
        };
        const actionButtonMap = createFeatureActionsConfig(
            actionFeatures,
            actionsBtn
        );
        console.log(' obj action map', actionButtonMap);
        let canShow = true;
        if (!user.isSuperUser && user?.role?.name !== 'Super User') {
            if (features?.docs?.length) {
                features?.docs?.forEach((item) => {
                    if (actionFeatures.includes(item?._id)) {
                        const action = actionButtonMap[item?._id];
                        const status = item?.status;
                        if (buttonStateSetter[action]) {
                            buttonStateSetter[action](status === 'active');
                        }
                    }
                });
            }
        } else {
            Object.values(buttonStateSetter).forEach((btn) => btn(canShow));
        }
    };

    useEffect(() => {
        dispatch(
            fetchEvents({
                populate: true,
                warOfClEvent: 'yes',
                sort: { name: 1 },
            })
        );
        computeWarOfCls();
        fetchRules();
    }, []);
    useEffect(() => {
        computeActiveFeature();
    }, [features])
    const eventsCols = [
        {
            Header: ' ',
            accessor: 'name',
            cellStyle: {
                width: '40%',
            },
        },
        {
            Header: ' ',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-row items-center gap-2 w-full">
                        <PrimaryButton
                            className={'w-[60%]'}
                            onClick={async (e) => {
                                e.stopPropagation();
                                console.log('row', row?.original);
                                setRequestData(row?.original);
                                setShowDescriptionModal(true);
                            }}
                        >
                            {row?.original?.subTitle
                                ? row?.original?.subTitle
                                : 'Event Subtitle'}
                        </PrimaryButton>
                        <PrimaryButton
                            className={'w-[40%]'}
                            onClick={async (e) => {
                                e.stopPropagation();
                                setRequestData(row?.original);
                                setShowDetailsModal(true);
                            }}
                        >
                            Details
                        </PrimaryButton>
                    </div>
                );
            },
            cellStyle: {
                width: '60%',
            },
        },
    ];

    const eventMemo = useMemo(() => (event?.docs ? event?.docs : []), [event]);

    const noOfClSlots = event?.docs?.[0]?.noOfClSlots || 0;
    const canRegister = clData?.userId !== user?._id && warClData.length < noOfClSlots;

    const rulesFormik = useFormik({
        initialValues: {
            rules: [],
        },
        validationSchema: object({
            rules: array()
                .of(string().trim().required('Rule cannot be empty'))
                .min(1, 'At least one rule is required'),
        }),
        onSubmit: async (values) => {
            try {
                setRulesLoading(true);
                const filteredRules = values.rules.filter((r) => r.trim() !== '');
                await authAxiosInstance.post('/warOfClRules/createRule', { rules: filteredRules });
                setRules(filteredRules);
                setIsEditingRules(false);
                toast.success("Rules updated successfully")
            } catch (error) {
                console.log(error);
                toast.error(error);
            } finally {
                setRulesLoading(false);
            }
        },
    });
    return (
        <PageWithCard
            heading={
                <>
                    <Link to={'/committee/event'}>Events</Link>
                    <span className="text-slate-200 inline-block px-1">
                        <ChevronRight size={14} className="-mb-0.5" />
                    </span>
                    <span>{'War of CL'}</span>
                    <span className="text-slate-200 inline-block px-1">
                        <ChevronRight size={14} className="-mb-0.5" />
                    </span>
                    <span>{'Registration'}</span>
                </>
            }
        >
            <DescriptionModal
                requestData={requestData}
                showDescriptionModal={showDescriptionModal}
                setShowDescriptionModal={setShowDescriptionModal}
            />

            <DetailsModal
                requestData={requestData}
                showDetailsModal={showDetailsModal}
                setShowDetailsModal={setShowDetailsModal}
            />

            <WarOfClDisclaimer
                requestData={requestData}
                showDisclaimerModal={showDisclaimerModal}
                setShowDisclaimerModal={setShowDisclaimerModal}
                computeWarOfCls={computeWarOfCls}
            />

            <div className="w-full md:w-1/2">

                <div className="mt-6">
                    <div className="flex items-center justify-between">
                        <h1 className="text-red-500 font-medium text-xl">
                            Event Details :
                        </h1>
                    </div>
                    {rulesLoading && !isEditingRules ? (
                        <p className="text-sm text-slate-200 mt-2"> <ClipLoader /> </p>
                    ) : (
                        <>
                            {!isEditingRules ? (
                                <ul className="mt-2">
                                    {rules.length > 0 ? (
                                        rules.map((rule, idx) => (
                                            <li
                                                key={idx}
                                                className="font-medium text-sm text-slate-200 list-disc list-inside"
                                            >
                                                {rule}
                                            </li>
                                        ))
                                    ) : (
                                        <li className="font-medium text-sm text-slate-200 list-none">
                                            No rules added yet.
                                        </li>
                                    )}
                                </ul>
                            ) : (
                                <form
                                    onSubmit={rulesFormik.handleSubmit}
                                    className="flex flex-col gap-4 bg-black p-4 rounded sm:rounded-md mt-2"
                                >
                                    {rulesFormik.values.rules.map((rule, idx) => (
                                        <div key={idx} className="flex items-center gap-2 w-full">
                                            <div className="w-full">
                                                <FormikInputGroup
                                                    formik={rulesFormik}
                                                    name={`rules[${idx}]`}
                                                    label={`Rule ${idx + 1}`}
                                                />
                                            </div>
                                            <div className="mt-5">
                                                <DangerButton
                                                    type="button"
                                                    disabled={rulesFormik.values.rules.length === 1}
                                                    onClick={() => {
                                                        const updated = rulesFormik.values.rules.filter((_, i) => i !== idx);
                                                        rulesFormik.setFieldValue('rules', updated);
                                                    }}
                                                >
                                                    <X size={14} />
                                                </DangerButton>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="flex gap-2 mt-2">
                                        <PrimaryButton
                                            type="button"
                                            onClick={() =>
                                                rulesFormik.setFieldValue('rules', [...rulesFormik.values.rules, ''])
                                            }
                                        >
                                            <Plus size={14} />
                                        </PrimaryButton>
                                        <PrimaryButton type="submit">
                                            {rulesLoading ? <ClipLoader size={16} color="#fff" /> : 'Save'}
                                        </PrimaryButton>
                                        <DangerButton
                                            type="button"
                                            onClick={() => {
                                                setIsEditingRules(false);
                                                rulesFormik.setFieldValue('rules', rules);
                                            }}
                                        >
                                            Cancel
                                        </DangerButton>
                                    </div>
                                </form>

                            )}

                            {typeof rulesFormik.errors.rules === 'string' && (
                                <p className="text-red-500 text-sm">{rulesFormik.errors.rules}</p>
                            )}
                        </>
                    )}
                    {canEditRules && !isEditingRules && (
                        <PrimaryButton
                            onClick={() => setIsEditingRules(true)}
                            className="mt-5"
                        >
                            Edit Rules
                        </PrimaryButton>
                    )}
                </div>

                { eventsCols?.length > 0 && eventMemo?.length > 0 &&
                    <div className="mt-4">
                        <TableWithHeading columns={eventsCols} data={eventMemo} />
                    </div>
                }
                {canRegister && (
                    canShowRegistration &&
                    <div>
                        <DangerButton
                            onClick={(e) => {
                                e.stopPropagation();
                                setRequestData(user);
                                setShowDisclaimerModal(true)
                            }}
                        >
                            Register
                        </DangerButton>
                    </div>
                )}
            </div>
        </PageWithCard>
    );
};

export default WarOfCLRegistration;
